module.exports = __webpack_public_path__ + "static/img/splash.286ec99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/splash.jpg
// module id = dyuW
// module chunks = 0